<template>
  <b-modal 
    :id="modalID" 
    header-class="align-items-center px-20 py-15 warning"
    body-class="p-20"
    footer-class="px-20 py-15"
    @hidden="close()"
  >
    <template #modal-header>
      <div class="modal-title fs-db-28">
        <span v-if="renderHtml" v-html="_title"></span>
        <span v-else>{{_title}}</span>
      </div>
      <div
        id="close-modal-confirm-upgrade"
        type="button"
        class="close-modal close"
        aria-label="Close"
        @click="close()"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div class="fs-sa-16">
        {{_msg}}
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="blue" @click.prevent="confirm()" v-if="['owner','reseller'].indexOf(adminType) >= 0">
        {{$t('engine.common.dialogAlertLimitSlideSection.lblUpgradePackage', languageEngine)}}
      </b-button>
      <b-button variant="default" @click="close()">
        {{$t('engine.common.dialogAlertLimitSlideSection.lblCancel', languageEngine)}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    modalID: {
      type: String,
      default: "modal-confirm-upgrade"
    },
    title: {
      type: String,
      default: ''
    },
    message:{
      type: String,
      default:  ''
    },
    renderHtml: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      adminType: "design/userPreference/adminType",
      limit: "design/page/limit"
    }),
    _title() {
      return this.title ? this.title : this.$t('engine.common.dialogAlertLimit.lblTitleLimit',this.languageEngine);
    },
    _msg() {
      return this.message ? this.message : this.$t('engine.common.dialogAlertLimit.lblDescLimit',this.languageEngine);
    }
  },
  methods: {
    close() {
      this.$bvModal.hide(this.modalID);
      this.$emit("clear");
    },
    confirm() {
      if(this.limit.packageID != 9) { // 6 = Free
        const url = `${process.env.VUE_APP_PUBLIC_URL}/${this.languageEngine}/upgradeplan`;
        window.open(url,'_blank');
      }
      this.$emit("confirmed");
      this.$bvModal.hide(this.modalID);
    },
  },
};
</script>